export default __webpack_public_path__ + "static/newsletter_modal_bg-bd645b0ff637841d950ccb77710ef6da.svg";